import { render, staticRenderFns } from "./BarnInterventionIncident.vue?vue&type=template&id=ac8af858&scoped=true"
import script from "./BarnInterventionIncident.vue?vue&type=script&lang=js"
export * from "./BarnInterventionIncident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8af858",
  null
  
)

export default component.exports